import { render, staticRenderFns } from "./HeadNewEdit.vue?vue&type=template&id=b013b984&scoped=true&"
import script from "./HeadNewEdit.vue?vue&type=script&lang=js&"
export * from "./HeadNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b013b984",
  null
  
)

export default component.exports